
export default function About() {
  const stats = [
    { number: '500+', label: 'Proyectos completados' },
    { number: '98%', label: 'Clientes satisfechos' },
    { number: '15+', label: 'Años de experiencia' },
    { number: '24h', label: 'Tiempo de respuesta' }
  ];

  const features = [
    'Más de 15 años',
    'Equipo certificado',
    'Garantía total',
    'Presupuesto sin compromiso'
  ];

  return (
    <section id="nosotros" className="py-24 px-6 bg-amber-50">
      <div className="max-w-7xl mx-auto">
        <div className="inline-flex items-center px-6 py-2 bg-white rounded-full mb-12">
          <span className="text-sm font-medium text-gray-800">Quiénes Somos</span>
        </div>

        <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-16 leading-tight">
          EXPERIENCIA Y COMPROMISO<br />
          EN CADA PROYECTO
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
          {features.map((feature, index) => (
            <div key={index} className="text-center md:text-left">
              <p className="text-base text-gray-700 font-medium">{feature}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-6xl md:text-7xl font-bold text-teal-700 mb-2">
                {stat.number}
              </div>
              <p className="text-sm text-gray-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
